import React, { useState } from "react";
import CustomDomainInformationPopup from "./CustomDomainInformationPopup";
import CustomDomainInputPopup from "./CustomDomainInputPopup";
import CustomDomainVerificationPopup from "./CustomDomainVerificationPopup";
import CustomDomainDisconnectPopup from "./CustomDomainDisconnectPopup";
import CustomDomainDisconnectInformationPopup from "./CustomDomainDisconnectInformationPopup";
import { getCustomDomainEntry } from "./customDomainEntry";
import { useSelector } from "react-redux";
import { selectCustomDomainData } from "../../../../redux/customDomain";

interface CustomDomainPopupsProps {
  onClose: () => void;
  shop_id: string;
  defaultShopUrl: string;
}

const CustomDomainPopups = ({
  onClose,
  shop_id,
  defaultShopUrl,
}: CustomDomainPopupsProps) => {
  const customDomain = useSelector(selectCustomDomainData);
  const isActive = customDomain?.isActive ?? false;
  const domainStatus = customDomain?.domainStatus ?? null;
  const customDomainUrl = customDomain?.customDomainUrl ?? null;
  const canDeleteOwnership = customDomain?.canDeleteOwnership ?? false;
  const [localHostnameState, setLocalHostnameState] = useState<string | null>(
    null,
  );
  const [step, setStep] = useState<
    "information" | "input" | "disconnect_information" | "verification"
  >("information");
  const currentDomainEntry = getCustomDomainEntry(isActive, domainStatus);

  if (step === "disconnect_information") {
    return (
      <CustomDomainDisconnectInformationPopup
        onClose={onClose}
        hostname={localHostnameState}
      />
    );
  }

  if (step === "verification" || currentDomainEntry === "verification") {
    return (
      <CustomDomainVerificationPopup onClose={onClose} shop_id={shop_id} />
    );
  }

  if (currentDomainEntry === "connect") {
    return step === "input" ? (
      <CustomDomainInputPopup
        onClose={onClose}
        onSubmit={() => setStep("verification")}
        shop_id={shop_id}
      />
    ) : (
      <CustomDomainInformationPopup
        onContinue={() => setStep("input")}
        onClose={onClose}
      />
    );
  }

  if (currentDomainEntry === "disconnect") {
    const derivedHostname = customDomainUrl
      ? customDomainUrl.replace(/^https?:\/\//, "").split("/")[0]
      : null;

    return (
      <CustomDomainDisconnectPopup
        onClose={onClose}
        onDisconnected={({ showFollowUp }) => {
          if (showFollowUp) {
            setStep("disconnect_information");
            setLocalHostnameState(derivedHostname);
          } else onClose();
        }}
        initialUrl={defaultShopUrl}
        customUrl={customDomainUrl}
        canDeleteOwnership={canDeleteOwnership}
        shop_id={shop_id}
      />
    );
  }
  if (currentDomainEntry === "blocked") {
    return (
      <CustomDomainVerificationPopup
        onClose={onClose}
        blocked
        shop_id={shop_id}
      />
    );
  }

  return null;
};

export default CustomDomainPopups;
